import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiChecklistHelperService } from './fi-checklist-helper.service';
import { FiChecklistStoreService } from '@fi-shared/checklist/fi-checklist-store.service';
import { FiObjectEditorInfoModule } from '@fi-shared/fi-object-editor-info/fi-object-editor-info.module';
import { FiChecklist2Service } from '@fi-shared/checklist/fi-checklist2.service';
import { FiChecklist2TranslationModule } from '@fi-shared/checklist/fi-checklist2-translation/fi-checklist2-translation.module';
import { FiChecklist2EditModule } from '@fi-shared/checklist/fi-checklist2-edit/fi-checklist2-edit.module';
import { FiChecklist2ListModule } from '@fi-shared/checklist/fi-checklist2-list/fi-checklist2-list.module';
import { FiChecklist2ScheduleModule } from '@fi-shared/checklist/schedule/fi-checklist2-schedule.module';
import { FiChecklist2ViewerModule } from '@fi-shared/checklist/fi-checklist2-viewer/fi-checklist2-viewer.module';
import { FiChecklistActionsHelperService } from '@fi-shared/checklist/fi-checklist-actions-helper.service';
import { FiChecklist2ReportModule } from '@fi-shared/checklist/fi-checklist2-report/fi-checklist2-report.module';
import { FiChecklist2SyncService } from '@fi-shared/checklist/fi-checklist2-sync.service';
import { FiChecklist2TemplateModule } from '@fi-shared/checklist/fi-checklist2-template/fi-checklist2-template.module';
import { FiChecklist2AuditModule } from '@fi-shared/checklist/fi-checklist2-audit/fi-checklist2-audit.module';
import { FiChecklist2ListColumnDefsModule } from '@fi-shared/checklist/fi-checklist2-list-column-defs/fi-checklist2-list-column-defs.module';
import { FiCheckpoint2HelperService } from '@fi-shared/checklist/fi-checkpoint2-helper.service';
import { FiChecklist2SideListOptionsHelperService } from './fi-checklist2-side-list-options-helper.service';

@NgModule({
    imports: [
        CommonModule,
        FiObjectEditorInfoModule,
        FiChecklist2TranslationModule,
        FiChecklist2EditModule,
        FiChecklist2ListModule,
        FiChecklist2ScheduleModule,
        FiChecklist2TemplateModule,
        FiChecklist2ViewerModule,
        FiChecklist2ReportModule,
        FiChecklist2AuditModule,
        FiChecklist2ListColumnDefsModule,
    ],
    providers: [
        FiChecklist2Service,
        FiChecklistHelperService,
        FiChecklist2SyncService,
        FiChecklistActionsHelperService,
        FiCheckpoint2HelperService,
        FiChecklistStoreService,
        FiChecklist2SideListOptionsHelperService,
    ],
    exports: [FiChecklist2EditModule],
})
export class FiChecklist2Module {}
